import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';

export const FinalCTA = () => {
  return (
    <section className="py-32 px-4 bg-[#0B0E14] text-center relative overflow-hidden pb-48">
       <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-royal-600/20 rounded-t-[100%] blur-[80px] -z-10 pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight"
        >
          This Is Your Chance to <span className="text-royal-400">Upgrade Your Income</span>
        </motion.h2>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          <CTAButton text="Upgrade to Silver 2.0 Now" className="transform scale-110" />
        </motion.div>
      </div>
    </section>
  );
};